import TextGradient from "@app/components/gradient/gradient-text";
import Image from "next/image";

const LookingForSection = () => {
  return (
    <div className="grid grid-cols-12 gap-y-8 px-8 pt-8 md:px-0 md:pt-10">
      <div className="col-span-12 md:col-span-6 md:mr-0 lg:my-24 lg:ml-24 md:pl-6 flex items-center justify-end">
        <div>
          <TextGradient overrideClassName="mobile-h2 md:h3 lg:h2 pb-6">
            {"We've got what they're looking for."}
          </TextGradient>
          <span className="text-body-md lg:text-body-lg text-text-color-mid-em">
            {`Get your customers excited about trash.​ A comprehensive solution has made it to the waste industry.
            We’ve got it. Let’s share it.`}
          </span>
        </div>
      </div>
      <div className="col-span-12 md:col-span-6 md:pl-20 flex justify-center md:justify-end">
        <div className="hidden md:block">
          <Image
            src="/images/partners/hero.png"
            alt="Waste Industry"
            height={640}
            width={640}
          />
        </div>
        <div className="md:hidden">
          <Image
            src="/images/partners/hero-mobile.png"
            alt="Waste Industry"
            height={640}
            width={640}
          />
        </div>
      </div>
    </div>
  );
};

export default LookingForSection;
